import { colors } from '@/theme/colors';

export default function CatalogBackgroundGradientSVG() {
  return (
    <svg
      width="1440"
      height="992"
      viewBox="0 0 1440 992"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.50">
        <g filter="url(#filter0_f_3899_161387)">
          <path
            d="M1520.47 364.592C1555.09 792.061 1366.47 766.32 1213.88 800.465C1061.28 834.609 998.117 623.457 967.861 488.24C937.606 353.023 1036.78 215.729 1189.38 181.584C1341.98 147.44 1490.21 229.375 1520.47 364.592Z"
            fill={colors.pink50}
          />
          <path
            d="M1520.07 364.652C1537.38 578.335 1498.87 678.585 1437.13 729.719C1406.25 755.296 1369.51 768.62 1330.94 777.681C1311.65 782.212 1291.91 785.675 1272.22 789.074C1271.19 789.251 1270.17 789.428 1269.14 789.604C1250.48 792.822 1231.88 796.029 1213.79 800.077C1175.74 808.591 1143.29 801.814 1115.52 784.761C1087.74 767.7 1064.64 740.341 1045.33 707.661C1006.72 642.297 983.375 555.759 968.248 488.154C938.05 353.193 1037.04 216.078 1189.47 181.971C1341.89 147.867 1489.86 229.707 1520.07 364.652Z"
            stroke="url(#paint0_linear_3899_161387)"
            strokeWidth="0.793866"
          />
        </g>
        <g filter="url(#filter1_f_3899_161387)">
          <path
            d="M643.659 1254.92C337.941 1344.08 22.032 1182.96 -61.9438 895.034C-145.92 607.109 33.8378 301.417 339.556 212.252C645.273 123.086 1288.7 108.337 1372.67 396.262C1456.65 684.187 949.377 1165.75 643.659 1254.92Z"
            fill={colors.aqua50}
          />
          <path
            d="M643.548 1254.54C338.019 1343.65 22.3455 1182.62 -61.5627 894.922C-145.471 607.229 34.1375 301.743 339.667 212.633C492.476 168.064 729.71 142.09 939.228 163.243C1043.99 173.819 1141.79 196.174 1218.64 233.859C1295.49 271.544 1351.34 324.535 1372.29 396.373C1393.25 468.223 1377.33 552.201 1336.83 639.189C1296.32 726.17 1231.26 816.112 1154.01 899.856C999.501 1067.36 796.312 1209.98 643.548 1254.54Z"
            stroke="url(#paint1_linear_3899_161387)"
            strokeWidth="0.793866"
          />
        </g>
        <g opacity="0.75" filter="url(#filter2_f_3899_161387)">
          <path
            d="M1440.56 -477.575C1476.04 94.7764 1192.49 67.6273 960.94 119.438C729.389 171.249 642.382 -109.663 602.042 -289.952C561.701 -470.242 716.707 -658.396 948.258 -710.206C1179.81 -762.017 1400.22 -657.864 1440.56 -477.575Z"
            fill={colors.blue30}
          />
          <path
            d="M1440.17 -477.519C1457.89 -191.416 1395.88 -55.2947 1300.65 15.8162C1253.01 51.3851 1197.03 70.719 1138.46 84.3974C1109.18 91.2365 1079.26 96.6602 1049.41 101.994C1047.86 102.272 1046.31 102.55 1044.75 102.827C1016.47 107.877 988.299 112.909 960.853 119.051C903.053 131.984 854.296 124.151 813.035 102.331C771.765 80.5059 737.966 44.6732 710.12 1.56502C654.424 -84.6588 622.598 -199.899 602.429 -290.039C562.155 -470.03 716.912 -658.035 948.345 -709.819C1179.76 -761.6 1399.87 -657.491 1440.17 -477.519Z"
            stroke="url(#paint2_linear_3899_161387)"
            strokeWidth="0.793866"
          />
        </g>
        <g filter="url(#filter3_f_3899_161387)">
          <path
            d="M234.562 -477.575C270.037 94.7764 -13.5081 67.6273 -245.059 119.438C-476.61 171.249 -563.616 -109.663 -603.957 -289.952C-644.297 -470.242 -489.291 -658.396 -257.74 -710.206C-26.1896 -762.017 194.222 -657.864 234.562 -477.575Z"
            fill={colors.blue30}
          />
          <path
            d="M234.168 -477.519C251.896 -191.416 189.881 -55.2947 94.6486 15.8162C47.0145 51.3851 -8.96667 70.719 -67.5343 84.3974C-96.8176 91.2365 -126.74 96.6602 -156.585 101.994C-158.139 102.272 -159.693 102.55 -161.247 102.827C-189.525 107.877 -217.7 112.909 -245.145 119.051C-302.946 131.984 -351.702 124.151 -392.964 102.331C-434.233 80.5059 -468.032 44.6732 -495.878 1.56502C-551.575 -84.6588 -583.4 -199.899 -603.569 -290.039C-643.843 -470.03 -489.086 -658.035 -257.654 -709.819C-26.2342 -761.6 193.876 -657.491 234.168 -477.519Z"
            stroke="url(#paint3_linear_3899_161387)"
            strokeWidth="0.793866"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_3899_161387"
          x="821.12"
          y="32.5306"
          width="844.813"
          height="912.923"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="70.6541"
            result="effect1_foregroundBlur_3899_161387"
          />
        </filter>
        <filter
          id="filter1_f_3899_161387"
          x="-281.058"
          y="-43.1024"
          width="1861.45"
          height="1521.06"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="99.2333"
            result="effect1_foregroundBlur_3899_161387"
          />
        </filter>
        <filter
          id="filter2_f_3899_161387"
          x="428.944"
          y="-890.218"
          width="1181.35"
          height="1182.64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="83.356"
            result="effect1_foregroundBlur_3899_161387"
          />
        </filter>
        <filter
          id="filter3_f_3899_161387"
          x="-777.054"
          y="-890.218"
          width="1181.35"
          height="1182.64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="83.356"
            result="effect1_foregroundBlur_3899_161387"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3899_161387"
          x1="1098.06"
          y1="275.93"
          x2="1277.83"
          y2="680.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.neutral100} stopOpacity="0.43" />
          <stop offset="1" stopOpacity="0" />
          <stop offset="1" stopColor={colors.neutral100} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3899_161387"
          x1="827.093"
          y1="416.537"
          x2="-48.9992"
          y2="917.664"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.neutral100} stopOpacity="0.43" />
          <stop offset="1" stopOpacity="0" />
          <stop offset="1" stopColor={colors.neutral100} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3899_161387"
          x1="806.795"
          y1="-580.002"
          x2="1034.75"
          y2="-32.5062"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.neutral100} stopOpacity="0.43" />
          <stop offset="1" stopOpacity="0" />
          <stop offset="1" stopColor={colors.neutral100} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3899_161387"
          x1="-399.204"
          y1="-580.002"
          x2="-171.253"
          y2="-32.5062"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.neutral100} stopOpacity="0.43" />
          <stop offset="1" stopOpacity="0" />
          <stop offset="1" stopColor={colors.neutral100} stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
